import { mailings } from './mailings';
import { messages } from './messages';
import { templates } from './templates';
import { senders } from './senders';
import { stats } from './stats';
import { archived_stats } from './archived_stats';

export const mailer = {
  namespaced: true,
  modules: {
    mailings,
    messages,
    templates,
    senders,
    stats,
    archived_stats
  }
};
